import { CatalogItem } from '../types/catalog';
export interface ProductCardProps {
  product: CatalogItem;
}
export function CartProdInfo({ product }: ProductCardProps) {
 const kv: Record<string, string> = Object.fromEntries(
    (product.props?.prop ?? []).map(p => [p.code, p.value])
  );
  const brand = kv['brand'] || '';
  const width = kv['width'] || '';
  const height = kv['height'] || kv['profile'] || '';
  const diameter = kv['diameter'] || '';
   const sizeLabel =
    width && height && diameter
      ? `${width}/${height} R${diameter}`
      : product.name || '';
return (
     <div className="flex-1 min-w-0">
                      <h4 className="font-medium text-sm truncate">{product.name}</h4>
                      <p className="text-xs text-gray-500">{product.code}</p>
                      <p className="text-xs text-[#ed8510]">{}</p>
                      <p className="font-semibold text-sm">{product.price}₽</p>
    </div>
)
}